module.exports = __webpack_public_path__ + "static/media/hn-tay-ho.770e47e0.svg";